module.exports = __webpack_public_path__ + "img/casting.68239c27.jpg";